export default __webpack_public_path__ + "static/media/R14.1ed33bd4.png";